import { axiosHelper } from '@setvi/shared/services';
import { AxiosMethods, QuotesV2Api } from '@setvi/shared/enums';

import type {
  GetQuotesV2Body,
  GetQuotesV2Response,
  QuoteV2Status,
  QuoteV2SummaryStatsResponse
} from './Types';

export enum QuotesV2QueryKey {
  GET_CONFIGURATION = 'GET_QUOTE_V2_CONFIGURATION',
  GET_STATUSES = 'GET_QUOTE_V2_STATUSES',
  GET_QUOTE = 'GET_QUOTE_V2',
  GET_ITEMS_METADATA = 'GET_QUOTE_V2_ITEMS_METADATA',
  GET_QUOTES = 'GET_QUOTES_V2',
  GET_SUMMARY_STATS = 'GET_QUOTES_V2_SUMMARY_STATS',
  PREVIEW_PDF = 'GET_QUOTE_V2_PREVIEW_PDF'
}

export const getQuoteV2ConfigurationQuery = () => ({
  queryKey: [QuotesV2QueryKey.GET_CONFIGURATION],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesV2Api.Configuration,
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    })
});

export const getQuoteV2StatusesQuery = () => ({
  queryKey: [QuotesV2QueryKey.GET_STATUSES],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesV2Api.Statuses,
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    }),
  select: (res: QuoteV2Status[]) => res.sort((a, b) => a.order - b.order)
});

export const getQuoteV2Query = (quoteId: string) => ({
  queryKey: [QuotesV2QueryKey.GET_QUOTE, quoteId],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesV2Api.Get.replace(':quoteId', quoteId),
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    })
});

export const getQuoteV2ItemsMetadataQuery = (quoteId: string) => ({
  queryKey: [QuotesV2QueryKey.GET_ITEMS_METADATA, quoteId],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesV2Api.ItemsMetadata.replace(':quoteId', quoteId),
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    })
});

export const getQuotesV2Query = (body: GetQuotesV2Body) => ({
  queryKey: [QuotesV2QueryKey.GET_QUOTES, body],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesV2Api.GetQuotes,
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    }) as Promise<GetQuotesV2Response>
});

export const getQuoteV2PreviewQuery = (
  quoteId: string,
  showManufacturerDetails?: boolean
) => ({
  queryKey: [
    QuotesV2QueryKey.PREVIEW_PDF,
    { quoteId, showManufacturerDetails }
  ],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesV2Api.PreviewPDF.replace(':quoteId', quoteId),
      params: { showManufacturerDetails },
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    })
});

export const getQuotesV2SummaryStatsQuery = (body: GetQuotesV2Body) => ({
  queryKey: [QuotesV2QueryKey.GET_SUMMARY_STATS, body],
  queryFn: () =>
    axiosHelper({
      endpoint: QuotesV2Api.SummaryStats,
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API,
      body
    }) as Promise<QuoteV2SummaryStatsResponse>
});
